import {baseApp,baseVersion} from './baseUrl';



function JSON_stringify(params) {
    let FD = new FormData();
    for (let key in params) {
        FD.append(key, params[key]);
    }
    return FD;
}
export async function request_utf(url, method, params, json) {
    let config = {
        credentials: 'include',
        method: method,
    };
    if (method == 'post') {
        config.body = json ? JSON.stringify(params) : JSON_stringify(params);
    }
    if (json) {
        config.headers = {
            'content-type': "application/json; charset=UTF-8"
            // mode:"no-cors"
        };
    }
    return fetch( url, config).then(res => res.json())
}

export async function request(url, method, params, json) {
    let config = {
        credentials: 'include',
        method: method,
    };
    if (method == 'post') {
        config.body = json ? JSON.stringify(params) : JSON_stringify(params);
    }
    if (json) {
        config.headers = {
            'content-type': "application/json"
            // mode:"no-cors"
        };
    }
    return fetch( url, config).then(res => res.json())
}

export async function get(url) {
    return request(url, "get");
}
export async function post_utf(url, params, json) {
    let new_params = params;
    new_params.token = sessionStorage.getItem("token");
    new_params.i_uid = sessionStorage.getItem("userid");
    new_params.app = baseApp;
    new_params.version = baseVersion;
    new_params.vc_lruname = sessionStorage.getItem("lruname");
    new_params.i_lruid = sessionStorage.getItem("userid");
    new_params.i_mid=sessionStorage.getItem('mids')?sessionStorage.getItem('mids'):null;
    new_params.lang = sessionStorage.getItem("vc_lang")?sessionStorage.getItem("vc_lang"):'zh_cn';
    new_params.uuid = sessionStorage.getItem("uuid");
    return request_utf(url, "post", new_params, json);
}

export async function post(url, params, json) {
    let new_params = params;
    new_params.token = sessionStorage.getItem("token");
    new_params.i_uid = sessionStorage.getItem("userid");
    new_params.app = baseApp;
    new_params.version = baseVersion;
    new_params.vc_lruname = sessionStorage.getItem("lruname");
    new_params.i_lruid = sessionStorage.getItem("userid");
    new_params.i_mid=sessionStorage.getItem('mids')?sessionStorage.getItem('mids'):null;
    new_params.lang = sessionStorage.getItem("vc_lang")?sessionStorage.getItem("vc_lang"):'zh_cn';
    new_params.uuid = sessionStorage.getItem("uuid");
    return request(url, "post", new_params, json);
}

//login
export async function dologin(url, params, json) {
    let new_params = params;
    new_params.app = "masterdata";
    new_params.version = "1.0";
    return request(url, "post", new_params, json);
}